import { render, staticRenderFns } from "./ProductFaqEditor.vue?vue&type=template&id=b9d8e234&scoped=true"
import script from "./ProductFaqEditor.vue?vue&type=script&lang=js"
export * from "./ProductFaqEditor.vue?vue&type=script&lang=js"
import style0 from "./ProductFaqEditor.vue?vue&type=style&index=0&id=b9d8e234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d8e234",
  null
  
)

export default component.exports